import { z } from 'zod';

export const formSchema = z.object({
  native: z.object({
    name: z.string({ message: 'Select native language' }),
    level: z.string()
  }),
  languages: z.array(
    z.object({
      name: z.string(),
      level: z.string()
    })
  )
});
